<template>
  <div
    v-if="details.quantity(result, resultInBox, thick) > 0"
    class="row mt-3"
  >
    <div class="col d-flex align-items-center">
      <p>{{ details.name }}<br>Qty: {{ details.quantity(result, resultInBox, thick) }}</p>
    </div>
    <div class="col d-flex align-items-center">
      <div
        class="px-4"
        :class="imgPadding"
      >
        <img
          :src="details.imgSrc"
          :alt="details.name"
          class="img-fluid"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccessoryItem',
  props: {
    details: {
      type: Object,
      required: true,
    },
    result: {
      type: Number,
      default: 0,
    },
    resultInBox: {
      type: Object,
      default: function () {
        return { orderQuantity: 0 };
      },
    },
    thick: {
      type: String,
      required: true,
    },
  },
  computed: {
    imgPadding() {
      // Change the width of the image for different products
      let padding;
      switch (this.details.productId) {
        case 58:
          padding = 'px-md-5';
          break;
        default:
          padding = '';
          break;
      }
      return padding;
    },
  },
};
</script>
